import { Menu, MenuItem, styled } from '@nextiva/next-ui-components';
import colors from 'styles/application/_base/_variables.scss';
import { pxToRem } from 'utils/pxToRemConverter';

export const SelectiveMenuStyles = styled(Menu)`
  .MuiList-root.MuiMenu-list.MuiList-padding {
    display: flex;
    flex-direction: column;
  }

  .MuiMenuItem-root {
    font-family: 'Lato', sans-serif;
    font-size: ${pxToRem('14px')};
    color: #333;
    width: 173px;
    padding: 3px 39px;

    &.MuiButtonBase-root {
      justify-content: start;
    }
  }

  .Mui-focusVisible {
    background-color: inherit;
  }

  .MuiListItem-button:focus {
    background-color: rgba(0, 0, 0, 0.08);
  }
  .MuiListItem-button:hover {
    font-weight: 700;
  }
`;

export const ActionsButtonStyles = styled('div')`
  .MuiButtonBase-root.MuiButton-root.MuiButton-contained {
    background-color: #fff;
    height: 38px;
    width: 98px;
    border: 1px solid ${colors.secondaryColor};
    border-radius: 4px;
    display: flex;
    color: ${colors.secondaryColor};
    font-weight: 600;
    box-shadow: none;

    &.button-border {
      border-color: #1592e6;
      box-shadow: 0 0 5px 0 #43b7ff;
    }

    &:hover {
      box-shadow: none;
    }
  }

  .MuiButton-label {
    margin-right: -10px;
  }
`;

export const DeleteStyles = styled(MenuItem)`
  color: ${colors.colorErrorPrimary} !important;
`;
